import { z } from "zod/v4";
import { refereeCourseSchema } from "../../schemas/bis";
import { fetchApi } from "../client/internal";

export const referees = {
	list: (kind?: string) => {
		const query = new URLSearchParams();
		if (kind) query.set("kind", kind);
		const qs = query.toString();
		return fetchApi(`/referees${qs ? `?${qs}` : ""}`, z.array(refereeCourseSchema));
	},
	get: (id: string) => fetchApi(`/referees/${id}`, refereeCourseSchema),
	create: (body: any) =>
		fetchApi(`/referees`, refereeCourseSchema, { method: "POST", body: JSON.stringify(body) }),
	update: (id: string, body: any) =>
		fetchApi(`/referees/${id}`, refereeCourseSchema, { method: "PUT", body: JSON.stringify(body) }),
	remove: (id: string) =>
		fetchApi(`/referees/${id}`, z.object({ deleted: z.boolean() }), { method: "DELETE" }),
};
